<template>
    <div>
        <h3>Ups...</h3>
        <p>Sigo en construcción</p>
    </div>
</template>

<script>
    export default {
        name: "Edit",
        props: {
            uuid: String,
        },
    }
</script>

<style scoped>

</style>
